import { IconEdit } from 'braid-design-system';
import queryString from 'query-string';
import React from 'react';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';
import type { ClientListingForListingsTab } from 'src/types/graphql-derived';

import Action from './Action';

interface EditActionProps {
  listing: ClientListingForListingsTab;
  onClick: () => void;
}

export const EditAction = ({ listing, onClick }: EditActionProps) => (
  <ExternalLink
    destination={queryString.stringifyUrl({
      url: getConfigValues().ADVERTISER_CENTRE_URL + Routes.CREATE_AD_URL,
      query: {
        ClientId: listing.clientId,
        listingId: listing.id,
      },
    })}
  >
    <Action Icon={IconEdit} action="Edit" onClick={onClick} />
  </ExternalLink>
);
